import React, { Component } from 'react';
import pwd from "../images/lokal/pwd.png"
import close from "../images/icons/close.png"
import $ from "jquery";
import { getData } from '../services';
import jwt from 'jsonwebtoken';
import config from '../config'
export default class login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      otp: '',
      errors: {},
      fields: {},
      userId: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.showLogin = this.showLogin.bind(this);
    this.verifyOTPSubmit = this.verifyOTPSubmit.bind(this);
    this.forgotPswrdClick = this.forgotPswrdClick.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.resendOtp = this.resendOtp.bind(this);
    //for forgot password
    this.forgotPassword = this.forgotPassword.bind(this);
    this.verifyOTPSubmitForForgot = this.verifyOTPSubmitForForgot.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.resendOtpForForgot = this.resendOtpForForgot.bind(this);
    //for forgot password
  }
  //for forgot password
  componentDidMount() {
    $("#username").val('');
    $(".popOverlay").click(function () {
      $("#username").val('');
      $(".retrievePasswordLogin").hide();
      $("#username").focus();
      $("#username").show();
      $("#password").hide();
      $("#passwordShow").hide();
      $("#btnSubmit").show();
      $("#btnLogin").hide();
      $("#otp").hide();
      $(".loginErrorMsg").text('');
      $(".OtpMsg").text("");
      $("#resendOTP").hide();
      $("#btnOTPLogin").hide();
    });
    $(".loginClose").click(function () {
      $("#username").val('');
      $(".retrievePasswordLogin").hide();
      $("#username").focus();
      $("#username").show();
      $("#password").hide();
      $("#passwordShow").hide();
      $("#btnSubmit").show();
      $("#btnLogin").hide();
      $("#otp").hide();
      $(".loginErrorMsg").text('');
      $(".OtpMsg").text("");
      $("#resendOTP").hide();
      $("#btnOTPLogin").hide();
      $(".loginPopUp").hide();
    });
  }
  resendOtpForForgot() {
    $("#otpForgot").focus();
    this.forgotPassword();
  }
  forgotPassword = (e) => {

    var characters = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let emailorMob = this.state.emailorMob;
    var forgotPswrdMsg = "";
    let formIsValid;
    $(".forgotPswrdMsg").text("");
    if (!emailorMob) {
      forgotPswrdMsg = "Please enter registered Email Id or Mobile Number";
      $("#emailorMob").focus()
      formIsValid = false;
    }
    else if (emailorMob.includes('@') && characters.test(emailorMob) === false) {
      forgotPswrdMsg = "Invalid Email Address"
      $("#emailorMob").focus()
      formIsValid = false;
    }
    else if (!emailorMob.includes('@') && emailorMob.length >= 20) {
      console.log("testttttttttttt",!emailorMob.includes('@'))
      forgotPswrdMsg = "Invalid Mobile Number";
      $("#emailorMob").focus()
      formIsValid = false;
    }
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $("#emailorMob").focus();
      $(".forgotPswrdMsg").text(forgotPswrdMsg);
      return false;
    }
    else {
      let siteId = localStorage.getItem('siteId');
      let userInput = emailorMob;

      const postData = {
        functionName: "userverification/forgotPassword",
        userInputInForgot: userInput,
        siteIdInForgot: siteId,
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          $("#emailorMobDiv").hide();
          $("#otpForgotDiv").show();
          $("#btnSendMeDiv").hide();
          $("#btnOTPForgotDiv").show();
          $("#otpForgot").focus();
          $(".OtpMsgForgot").text("OTP has been sent to your Registered Mobile Number");
          setTimeout(function () { $("#resendOTPForgot").show(); }, 30000);
          this.setState({
            userId: data.data.userId
          });
        }
        else {
          $(".forgotPswrdMsg").text("You are not a Registered User");
          formIsValid = false;
          return false;
        }
      })
    }
  }
  verifyOTPSubmitForForgot = (e) => {
    e.preventDefault();
    let otp = this.state.otpForgot;
    let userInput = this.state.emailorMob
    $(".OtpMsgForgot").text("");
    if (!otp) {
      $(".OtpMsgForgot").text("OTP Required");
      return false;
    }
    else {
      const postData = {
        functionName: "userverification/forgotPasswordOtp",
        siteId: localStorage.getItem('siteId'),
        userInput: userInput,
        otp: otp,
        userId: this.state.userId
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          $("#emailorMobDiv").hide();
          $("#otpForgotDiv").hide();
          $("#newPasswordDiv").show();
          $("#confirmPasswordDiv").show();
          $("#btnSendMeDiv").hide();
          $("#btnOTPForgotDiv").hide();
          $("#btnChangePasswordDiv").show();
          $("#newPassword").focus();
          let userId = data.data.userId;
          this.setState({
            userId: userId
          });
        }
        else {
          $(".OtpMsgForgot").text("Incorrect OTP");
          return false;
        }
      })
    }
  }
  resetPassword = (e) => {
    e.preventDefault();
    let userId = this.state.userId;
    let newPassword = $("#newPassword").val();
    let confirmPassword = $("#confirmPassword").val();
    var resetPasswordMsg = "";
    $(".resetPasswordMsg").text("");
    let formIsValid;
    if (!newPassword) {
      $("#newPassword").focus();
      resetPasswordMsg = "Please enter new password"
      formIsValid = false;
    }
    else if (!confirmPassword) {
      $("#confirmPassword").focus();
      resetPasswordMsg = "Please enter confirm password"
      formIsValid = false;
    }
    else if (newPassword !== confirmPassword) {
      $("#newPassword").focus();
      resetPasswordMsg = "New password and confirm password donot match"
      formIsValid = false;
    }
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $(".resetPasswordMsg").show()
      $(".resetPasswordMsg").text(resetPasswordMsg);
      return false;
    }
    else {
      $(".resetPasswordMsg").text("")
      const token = jwt.sign({
        userIdInResetPwrd: userId,
        newPasswordInResetPwrd: confirmPassword
      }, config.jwtSecret);
      const postData = {
        functionName: "userverification/resetPassword",
        token: token
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          $(".resetPasswordMsg").text("Password updated successfully");
          alert("Password updated successfully")
          $(".loginForgotHide").show();
          $(".loginPopUp").show();
          $(".retrievePasswordLogin").hide();
          $("#username").focus();
          $("#username").val('');
        }
      })
    }
  }
  signUpClick() {
    $(".loginPopUp").hide();
    $(".signUpPopUp").show();
    $("#txtFirstName").focus();
  }
  forgotPswrdClick() {
    $(".retrievePasswordLogin").show();
    $("#emailorMob").val('');
    $("#otpForgot").val('');
    $("#newPassword").val('');
    $("#confirmPassword").val('');
    $("#emailorMobDiv").show();
    $("#btnSendMeDiv").show();
    $(".resetPasswordMsg").text("");
    $("#newPasswordDiv").hide();
    $("#otpForgotDiv").hide();
    $("#btnOTPForgotDiv").hide();
    $("#confirmPasswordDiv").hide();
    $(".loginForgotHide").hide();
    $("#btnChangePasswordDiv").hide();
    $("#resendOTPForgot").hide();
    $("#emailorMob").focus();
    $(".OtpMsgForgot").text("");
  }
  onLoad = (e) => {

    if (!$("#btnSubmit").is(":hidden")) {
      this.showLogin(e);
    }
    else if (!$("#btnOTPLogin").is(":hidden")) {
      this.verifyOTPSubmit(e);
    }
    else {
      this.onSubmit(e);
    }
  }
  resendOtp() {
    $("#otp").focus();
    this.showLogin();
  }
  showLogin = (e) => {

    $("#resendOTP").hide();
    let username = this.state.username;
    var loginErrorMsg = "";
    let formIsValid;
    $(".loginErrorMsg").text("");
    var characters = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var email = this.state.username;
    var splitemail = email.split(/\r|\r\n|\n/);
    var emailcount = splitemail.length;
    if (!username) {
      loginErrorMsg = "Please enter registered Email Id or Mobile Number";
      formIsValid = false;
    }
    else if (username.includes('@') && characters.test(splitemail[emailcount - 1]) === false && $("#username").val() !== "") {
      loginErrorMsg = "Invalid Email Id";
      $("#username").focus();
      formIsValid = false;
    }
    else if (username.includes('@')) {
      $("#username").hide();
      $("#password").show();
      $("#passwordShow").show();
      $("#btnSubmit").hide();
      $("#btnLogin").show();
      $("#password").focus();
    }
    else if (!username.includes('@') && username.length >= 20) {
      loginErrorMsg = "Invalid Mobile Number";
      formIsValid = false;
    }
    else if (!username.includes('@') ) {
      $("#btnSubmit").hide();
      $("#btnSubmitProcessing").show();
      let siteId = localStorage.getItem('siteId');
      let type = "Login";
      let mobileNumber = username;
      let otp = null;
      const postData = {
        functionName: "userverification/sms",
        siteIdInSms: siteId,
        typeInSms: type,
        mobileNumberInSms: mobileNumber,
        otpInSms: otp
      }
      getData(postData).then((data) => {
        if (data.data.success === "0") {
          $(".loginErrorMsg").text("Mobile Number is not registered");
          $("#btnSubmit").show();
          $("#btnSubmitProcessing").hide();
          formIsValid = false;
          return false;
        }
        else if (data.data.success === "1" && data.data.userCountryId == '1') {
          $("#btnSubmitProcessing").hide();
          $("#username").hide();
          $("#otp").show();
          $("#btnSubmit").hide();
          $("#btnOTPLogin").show();
          $("#otp").focus();
          $(".OtpMsg").text("OTP has been sent to your Mobile Number");
          setTimeout(function () { $("#resendOTP").show(); }, 30000);
        }
        else if (data.data.success === "1" && data.data.userCountryId != '1') {
          this.setState({
            username: data.data.userEmailId
          });
          $("#btnSubmitProcessing").hide();
          $("#username").hide();
          $("#btnSubmit").hide();
          // $("#btnOTPLogin").show();
          $("#password").show();
          $("#passwordShow").show();
          $("#btnSubmit").hide();
          $("#btnLogin").show();
          $("#password").focus();

        }
        else {
          formIsValid = true;
        }
      })
    }
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $(".loginErrorMsg").text(loginErrorMsg);
      return false;
    }
  }
  verifyOTPSubmit = (e) => {
    var themeId = localStorage.getItem('themeId')
    e.preventDefault();
    $(".OtpMsg").text("");
    let mobileNumber = this.state.username;
    let otp = this.state.otp;
    let siteId = localStorage.getItem('siteId');
    let type = "Login";
    if (!otp) {
      $(".loginErrorMsg").text("OTP Required");
      return false;
    }
    else {
      const postData = {
        functionName: "userverification/sms",
        siteIdInSms: siteId,
        typeInSms: type,
        mobileNumberInSms: mobileNumber,
        otpInSms: otp
      }
      getData(postData).then((data) => {
        if (data.data.success === "1") {
          localStorage.setItem('userId', data.data.result.userData[0].userId);
          localStorage.setItem('displayName', data.data.result.userData[0].displayName);
          localStorage.setItem('role', data.data.result.userData[0].role);
          window.sessionStorage.setItem('mobileNumber', data.data.result.userData[0].mobileNumber);
          window.sessionStorage.setItem('emailId', data.data.result.userData[0].emailId);
          this.setState({
            loginDetails: data.data.result.userData
          });
          if (window.sessionStorage.getItem('loginFromCart')) {
            window.location.href = "/OrderSummary";
            window.sessionStorage.removeItem('loginFromCart')
          }
          else {
            if (window.sessionStorage.getItem('mainCategoryId') === '5') {
              window.location.href = "/restaurantListing/0/0/";
            }
            else if (window.sessionStorage.getItem('mainGroupCategory') === '8') {
              if (themeId === '38' || themeId === '2') {
                window.location.href = "/";
              }
              else {
                window.location.href = "/cmItemListing/0/0/0/";
              }

            }
            else {
              if (themeId === '36') {
                window.location.href = '/home'
              }
              else {
                window.location.href = '/'
              }
            }
          }
        }
        else {
          $(".loginErrorMsg").text("Invalid OTP");
          return false;
        }
      })
    }
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById("btnSubmit").click();
    }

  }
  _handleForgotPwd = (e) => {
    if (e.key === 'Enter') {
      document.getElementById("btnOTPForgot").click();
    }
  }
  _handleKey = (e) => {
    if (e.key === 'Enter') {
      document.getElementById("btnSendMe").click();
    }
  }

  onSubmit = (e) => {

    var themeId = localStorage.getItem('themeId')
    e.preventDefault();
    let username = this.state.username;
    let password = this.state.password;
    var loginErrorMsg = "";
    let formIsValid;
    $(".loginErrorMsg").text("");
    if (!username) {
      loginErrorMsg = "User name required";
      formIsValid = false;
    }
    else if (!password) {
      loginErrorMsg = "Password required";
      formIsValid = false;
    }
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $(".loginErrorMsg").text(loginErrorMsg);
      return false;
    }
    else {
      $(".loginErrorMsg").text("");
      let siteId = localStorage.getItem('siteId');
      const token = jwt.sign({
        username: this.state.username,
        password: this.state.password,
      }, config.jwtSecret);
      const postData = {
        functionName: "userlogin",
        isBackend: false,
        siteId: siteId,
        token: token
      }
      getData(postData).then((data) => {
        console.log("login", data)
        if (data.data.success === "1") {
          if (data.data.result.userData[0].role === "ROLE_ADMIN" || data.data.result.userData[0].role === "ROLE_MAPPING_ADMIN") {
            alert("Invalid User")
          }
          else if (data.data.result.userData[0].isBuyer === '1') {
            localStorage.setItem('role', data.data.result.userData[0].role);
            localStorage.setItem('userId', data.data.result.userData[0].userId);
            window.sessionStorage.setItem('loginStoreId', data.data.result.userData[0].storeId)
            window.sessionStorage.setItem('userEmailId', data.data.result.userData[0].emailId);
            localStorage.setItem('displayName', data.data.result.userData[0].displayName);
            window.sessionStorage.setItem('userMobileNumber', data.data.result.userData[0].mobileNumber);
            this.setState({
              loginDetails: data.data.result.userData
            });
            if (window.sessionStorage.getItem('loginFromCart')) {
              window.location.href = "/OrderSummary";
              window.sessionStorage.removeItem('loginFromCart')
            }
            else {
              if (window.sessionStorage.getItem('mainCategoryId') === '5') {
                window.location.href = "/restaurantListing/0/0/";
              }
              else if (window.sessionStorage.getItem('mainGroupCategory') === '8') {
                if (themeId === '38' || themeId === '2') {
                  window.location.href = "/";
                }
                else {
                  window.location.href = "/cmItemListing/0/0/0/";
                }
              }
              else {
                if (themeId === '36') {
                  window.location.href = '/home'
                }
                else {
                  window.location.href = '/'
                }
              }
            }
          }
          else {
            localStorage.setItem('displayName', data.data.result.userData[0].displayName);
            localStorage.setItem('role', data.data.result.userData[0].role);
            localStorage.setItem('userId', data.data.result.userData[0].userId);
            window.sessionStorage.setItem('loginStoreId', data.data.result.userData[0].storeId)
            window.sessionStorage.setItem('userEmailId', data.data.result.userData[0].emailId);
            window.sessionStorage.setItem('mainGroupCategoryId', data.data.result.userData[0].mainGroupCategoryId);
            if (data.data.result.userData[0].role == "ROLE_STORE") {
              window.sessionStorage.setItem('sellerId', data.data.result.userData[0].sellerId);
              window.sessionStorage.setItem('storeId', data.data.result.userData[0].storeId);
            }
            else {
              window.sessionStorage.setItem('sellerId', data.data.result.userData[0].userId);
              window.sessionStorage.setItem('storeId', null);
            }
            window.open(data.data.result.userData[0].redirectUrl, "_blank");
          }
        }
        else if (data.data.success === "0") {
          $("#username").show();
          $("#password").hide();
          $("#passwordShow").hide();
          $("#btnSubmit").show();
          $("#btnLogin").hide();
          $(".loginErrorMsg").text(data.data.errorMessage);
        }
        else {
          $("#username").show();
          $("#password").hide();
          $("#passwordShow").hide();
          $("#btnSubmit").show();
          $("#btnLogin").hide();
          $(".loginErrorMsg").text(data.data.errorMessage);
        }
      });
    }
  }
  handleInputChange = (event) => {
    const { value, name } = event.target;
    if (name === "username") {
      const re = /^[0-9\b]+$/;
      if (re.test(value) && value.length === 10) {
        $("#btnSubmit").text("Submit")
      }
      // else {
      //   $("#btnSubmit").text("Submit")
      // }
    }
    this.setState({
      [name]: value
    });
  }
  handleOtpChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ otp: e.target.value })
    }
  }
  showPassword() {
    document.getElementById("passwordShow").style.visibility = "hidden";
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
    setTimeout(function () { document.getElementById("passwordShow").style.visibility = "visible"; x.type = "password"; }, 1500);
  }
  render() {
    return (
      <div>
        <div className="popOverlay"></div>
        <div className="loginPop loginForgotHide">
          <div className="loginHead">
            <span className="loginClose"><img src={close} alt="" /></span>
            <div className="loginText">
              Welcome!
              <span>Login with your Email Id/Phone Number</span>
            </div>
          </div>
          <div className="loginForm gsa-loginforms">
            <form>
              <div className="errorMsg loginErrorMsg"></div>
              <div className="errorMsg OtpMsg"></div>
              <div className="loginFormList">
                <input type="text" className="inputTextField" autoComplete="off" id="username" name="username" onChange={this.handleInputChange} onKeyDown={this._handleKeyDown} placeholder="Email Id/Phone Number" />
              </div>
              <div className="loginFormList">
                <input type="text" style={{ display: 'none' }} className="inputTextField otpTextField" id="otp" name="otp" value={this.state.otp} onKeyDown={this._handleKeyDown} onChange={this.handleOtpChange} placeholder="OTP" />
                <input type="password" style={{ display: 'none' }} className="form-control" id="password" name="password" value={this.state.password} onKeyDown={this._handleKeyDown} onChange={this.handleInputChange} placeholder="Password" />
                <img src={pwd} alt="" className="gsa-pwd-img" id="passwordShow" style={{ display: 'none', cursor: 'pointer' }} onClick={() => this.showPassword()} />
                <span id="resendOTP" className="otpButton" onClick={this.resendOtp} style={{ display: 'none' }}>Resend OTP</span>
              </div>
              <div className="forgotLink" onClick={this.forgotPswrdClick}><span>Forgot Password?</span></div>
              <div className="formButton"><span className="loginButton" onClick={this.onLoad} type="submit" id="btnSubmit" value="Submit" >Submit</span></div>
              <div className="formButton" style={{ display: 'none' }} id="btnSubmitProcessing"><span className="loginButton" style={{ cursor: 'default', background: '#b3b3b3' }} type="submit" value="Submit" >Processing...</span></div>
              <div className="formButton"><span className="loginButton" style={{ display: 'none' }} type="submit" id="btnOTPLogin" value="Login/Verify" onClick={this.onLoad} >Login / Verify</span></div>
              <div className="formButton"><span className="loginButton" style={{ display: 'none' }} type="submit" id="btnLogin" value="Login" onClick={this.onLoad} >Login</span></div>
              <div className="socialButtons">
              </div>
              <div className="registrationText">Don’t have an account?
                <span onClick={this.signUpClick}>Sign up</span>
              </div>
            </form>
          </div>
        </div>
        <div className="loginPop retrievePasswordLogin" style={{ display: 'none' }}>
          <div className="loginHead">
            <span className="loginClose"><img src={close} alt="" /></span>
            <div className="loginText">
              Retrieve Password!
            </div>
          </div>
          <div className="loginForm">
            <form>
              <div className="errorMsg forgotPswrdMsg"></div>
              <div className="errorMsg OtpMsgForgot"></div>
              <div className="errorMsg resetPasswordMsg"></div>
              <div id="emailorMobDiv" className="loginFormList">
                <input type="text" className="inputTextField" id="emailorMob" name="emailorMob" onChange={this.handleInputChange} onKeyDown={this._handleKey} required placeholder="Email or Mobile Number" />
              </div>
              <div id="otpForgotDiv" className="loginFormList" style={{ display: 'none' }}>
                <input type="text" className="inputTextField otpTextField" id="otpForgot" name="otpForgot" onChange={this.handleInputChange} required placeholder="OTP" onKeyDown={this._handleForgotPwd} />
                <span id="resendOTPForgot" className="otpButton" onClick={this.resendOtpForForgot} style={{ display: 'none' }}>Resend OTP</span>
              </div>
              <div id="newPasswordDiv" className="loginFormList" style={{ display: 'none' }}>
                <input type="password" className="inputTextField" tabIndex='1' id="newPassword" name="newPassword" onChange={this.handleInputChange} required placeholder="New Password" />
              </div>
              <div id="confirmPasswordDiv" className="loginFormList" style={{ display: 'none' }}>
                <input type="password" className="inputTextField" tabIndex='2' id="confirmPassword" name="confirmPassword" onChange={this.handleInputChange} required placeholder="Confirm Password" />
              </div>
              <div id="btnSendMeDiv" className="formButton"><span className="loginButton" onClick={this.forgotPassword} id="btnSendMe">Send Me</span></div>
              <div id="btnOTPForgotDiv" className="formButton" style={{ display: 'none' }}><span className="loginButton" onClick={this.verifyOTPSubmitForForgot} id="btnOTPForgot" value="Submit" >Submit</span>
              </div>
              <div id="btnChangePasswordDiv" tabIndex='3' className="formButton" style={{ display: 'none' }}><span className="loginButton" onClick={this.resetPassword} id="btnChangePassword" value="Change Password" >Change Password</span></div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}
